import { render, staticRenderFns } from "./AccountSelector.vue?vue&type=template&id=dea7b3ba"
import script from "./AccountSelector.vue?vue&type=script&lang=js"
export * from "./AccountSelector.vue?vue&type=script&lang=js"
import style0 from "./AccountSelector.vue?vue&type=style&index=0&id=dea7b3ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports